module.exports = __webpack_public_path__ + "img/bt_bet.863eb21a.png";